export default __webpack_public_path__ + "static/media/AppealCSTTemplate.8ff5b9ba.xlsx";